import { Grid, Stack, useTheme } from "@mui/material"
import AppAutocomplete from "components/AppAutocomplete"
import ImageUploadField from "components/FileUpload/ImageUploadField"
import ImageCropper from "components/ImageCropper"
import AppTextArea from "components/StyledComponents/AppTextArea"
import AppTextField from "components/StyledComponents/AppTextField"
import { handleTimeChange } from "helpers/functions"
import AddIngrediant from "pages/private/DVM_Console/DMV_Menu/AddDMVMenuItems/components/AddIngrediant"
import AddUniqueFact from "pages/private/DVM_Console/DMV_Menu/AddDMVMenuItems/components/AddUniqueFact"
import React, { useState } from "react"
import UploadPdfField from "../UploadPdfField"
import WeeklySchedule from "../WeeklySchedule"
import ImageUploadWithPreview from "components/FileUploadWithPreview/ImageUploadPreview"
import RedCloseIcon from "assets/icons/RedCloseIcon.svg"
import AppButton from "components/StyledComponents/AppButton"
import { AddOutlined } from "@mui/icons-material"
import { uploadImageAction } from "redux/hotel/action"
import { useDispatch } from "react-redux"

const SignatureDishes = ({ data, formik, type }) => {
  const theme = useTheme()
  const [uploadType, setUploadType] = useState("")
  const [openCrop, setCrop] = useState(false)
  const [fileDetails, setFileDetails] = useState(null)
  const [imageObjectURL, setImageObjectUrl] = useState(null)
  const [croppingIndex, setCroppingIndex] = useState(null)
  const [imageKey, setImageKey] = useState("")
  const dispatch = useDispatch()

  const onImageUpload = (image, id, fieldPath, key) => {
    setUploadType("image")
    setCroppingIndex(id)
    setImageKey(key)
    setCrop(true)
    setFileDetails(image)
    setImageObjectUrl(URL.createObjectURL(image))
  }

  function handleCroppedImage(image, id) {
    if (uploadType === "image") {
      let data = new FormData()
      data.append("media", image)
      data.append("media_type", "IMAGE")
      data.append("content_type", image.type)
      formik.setFieldValue(`${type}[${id}].${imageKey}`, image)
      dispatch(uploadImageAction({ data, fieldKey: imageKey, type, index: id }))
      setUploadType("")
    }
  }

  function showCropperModal(imageObjectURL, fileDetails) {
    return (
      <ImageCropper
        setSelectedImage={(image) => handleCroppedImage(image, croppingIndex)}
        srcImage={imageObjectURL}
        fileDetail={fileDetails}
        aspectRatio={uploadType === "uploadThumbnail" && 1}
        onClose={setCrop}
        openCrop={openCrop}></ImageCropper>
    )
  }
  const handleImageDelete = (dishIndex, fieldKey) => {
    formik.setFieldValue(`${type}[${dishIndex}].${fieldKey}`, null)
  }

  const handleDeleteSignatureDishes = (indexToRemove) => {
    const updatedDishes = formik.values?.[type]?.filter((_, i) => i !== indexToRemove)
    formik.setFieldValue(type, updatedDishes)
  }
  const getComponentType = (label) => {
    switch (label) {
      case "text":
        return "textField"
      case "image":
      case "images":
        return "imageUpload"
      case "file":
        return "uploadPdf"
      case "multiple_image":
        return "restaurantImageUpload"
      default:
        return "textField"
    }
  }

  return (
    <Grid item xs={12}>
      {Array.isArray(formik?.values?.[type]) &&
        formik?.values?.[type]?.length > 0 &&
        formik?.values?.[type]?.map((dish, id) => (
          <Stack key={`${type}-${id}`} direction="row" justifyContent="start">
            {showCropperModal(imageObjectURL, fileDetails)}
            <Grid
              container
              spacing={2}
              width="95%"
              mt={3}
              mb={3}
              mx="auto"
              sx={{
                border: `2px solid ${theme.palette.secondary.default}`,
                borderRadius: "8px",
                pb: 3,
                pr: 2
              }}>
              {data?.[0]?.fields?.map((field, index) => {
                const fieldKey = field?.key
                const componentType = getComponentType(field?.type)
                const fieldName = field?.label
                const fieldPath = `${type}.${id}.${field.key}`
                const fieldValue = formik?.values?.[type]?.[id]?.[fieldKey]
                const fieldError = formik?.errors?.[type]?.[id]?.[fieldKey]
                const fieldTouched = formik?.touched?.[type]?.[id]?.[fieldKey]

                switch (componentType) {
                  case "textField":
                    return (
                      <Grid item xs={12}>
                        <AppTextField
                          id={fieldPath}
                          name={fieldPath}
                          type="text"
                          fullWidth
                          isRequired={fieldKey === "name"}
                          label={fieldName}
                          isUpperCase
                          placeholder={`Enter ${fieldName}`}
                          value={fieldValue || ""}
                          onBlur={formik?.handleBlur}
                          onChange={formik?.handleChange}
                          error={Boolean(fieldTouched && fieldError)}
                          touched={fieldTouched}
                          helperText={fieldTouched && fieldError}
                        />
                      </Grid>
                    )

                  case "numberField":
                    return (
                      <Grid item xs={12}>
                        <AppTextField
                          id={fieldPath}
                          name={fieldPath}
                          type="number"
                          fullWidth
                          label={fieldName}
                          isUpperCase
                          placeholder={`Enter ${fieldName}`}
                          value={fieldValue || ""}
                          onChange={formik?.handleChange}
                          onBlur={formik?.handleBlur}
                          error={Boolean(fieldTouched && fieldError)}
                          touched={fieldTouched}
                          helperText={fieldTouched && fieldError}
                        />
                      </Grid>
                    )

                  case "textArea":
                    return (
                      <Grid item xs={12}>
                        <AppTextArea
                          label={fieldName}
                          minRows={5}
                          maxRows={15}
                          placeholder={`Enter ${fieldName}`}
                          name={fieldPath}
                          value={fieldValue}
                          onChange={formik?.handleChange}
                          onBlur={formik?.handleBlur}
                          error={Boolean(fieldError)}
                          touched={fieldTouched}
                          helperText={fieldError}
                        />
                      </Grid>
                    )

                  case "autoComplete":
                    return (
                      <Grid item xs={12}>
                        <AppAutocomplete
                          id={fieldKey}
                          isUpperCase
                          placeholder={`Enter ${fieldName}`}
                          label={fieldName}
                          showValue
                          value={fieldValue}
                          error={Boolean(fieldError)}
                          helperText={fieldError}
                          touched={fieldTouched}
                          onChange={(event, newValue) => formik.setFieldValue(fieldPath, newValue)}
                        />
                      </Grid>
                    )

                  case "imageUpload":
                    return (
                      <Grid item xs={12}>
                        <ImageUploadField
                          label={fieldName}
                          isVariant
                          placeholder={`Upload ${fieldName}`}
                          value={fieldValue}
                          onChange={(e) => onImageUpload(e, id, fieldPath, fieldKey, field.type)}
                          onDelete={() => handleImageDelete(id, fieldKey)}
                          error={fieldError}
                          touched={fieldTouched}
                        />
                      </Grid>
                    )

                  case "restaurantImageUpload":
                    return (
                      <Grid item xs={12} key={index}>
                        <ImageUploadWithPreview
                          label={fieldName}
                          isVariant
                          placeholder="Upload Image"
                          value={fieldValue}
                          onChange={(e) => onImageUpload(e, "preview", id)}
                          onDelete={() => handleImageDelete(id, "preview", fieldKey)}
                        />
                      </Grid>
                    )

                  case "uploadPdf":
                    return (
                      <Grid item xs={12}>
                        <UploadPdfField
                          title={fieldName}
                          label={fieldName}
                          formik={formik}
                          type={type}
                        />
                      </Grid>
                    )

                  case "uniqueFact":
                    return (
                      <React.Fragment>
                        <AddUniqueFact
                          formik={formik}
                          values={fieldValue || []}
                          name={fieldPath}
                          buttonText={`+ Add ${fieldKey}`}
                          label={fieldKey}
                        />
                      </React.Fragment>
                    )

                  case "ingredients":
                    return (
                      <React.Fragment>
                        <AddIngrediant
                          formik={formik}
                          values={fieldValue || []}
                          name={fieldPath}
                          buttonText={`+ Add ${fieldKey}`}
                          label={fieldKey}
                        />
                      </React.Fragment>
                    )

                  case "weeklySchedule":
                    return (
                      <Grid item xs={12}>
                        <WeeklySchedule
                          title={fieldKey}
                          label={fieldKey}
                          formik={formik}
                          value={fieldValue}
                          type={type}
                        />
                      </Grid>
                    )

                  case "timeField":
                    return (
                      <Grid item xs={12} key={index}>
                        <AppTextField
                          id={fieldPath}
                          type="time"
                          fullWidth
                          label={fieldKey}
                          isUpperCase
                          value={fieldValue}
                          onChange={(e) => handleTimeChange(e, fieldPath, formik)}
                          error={Boolean(fieldTouched && fieldError)}
                          helperText={fieldTouched && fieldError}
                        />
                      </Grid>
                    )

                  default:
                    return null
                }
              })}
            </Grid>
            <Stack width="5%">
              {id !== 0 && (
                <img
                  className="flex-shrink-0"
                  role="button"
                  src={RedCloseIcon}
                  onClick={() => handleDeleteSignatureDishes(id)}
                  alt="Delete"
                  style={{ width: 30, marginTop: "20px", marginLeft: "10px" }}
                />
              )}
            </Stack>
          </Stack>
        ))}
      <Grid item xs={12} mt={3}>
        <AppButton
          fullWidth
          onClick={() => {
            const currentDishes = formik?.values?.[type] || []

            const newDish = {}

            data?.[0]?.fields?.forEach((field) => {
              newDish[field.key] = ["uniqueFact", "ingredients"].includes(field.type) ? [] : ""
            })

            formik.setFieldValue(type, [...currentDishes, structuredClone(newDish)])
          }}
          startIcon={<AddOutlined />}>
          Add new signature dish
        </AppButton>
      </Grid>
    </Grid>
  )
}

export default SignatureDishes
